import { List } from 'antd';
import { DocumentPreviewButton } from 'components/documents/document-item/components/document-preview-button';
import { useGetCargoDocumentLink } from 'client-app/api/documents/use-get-cargo-document-link';
import { DocumentDownloadButton } from '../document-download-button';
import styles from './document-list-item.module.scss';
import type { IDocumentListItemProps } from './types';

export const DocumentListItem: React.FC<IDocumentListItemProps> = ({ document, description }) => {
  const { mutateAsync: getLinkForPreview } = useGetCargoDocumentLink();

  return (
    <List.Item
      key={document.id}
      style={{ padding: '8px 0' }}
      className={styles.listItem}
      actions={[
        <DocumentPreviewButton
          key='preview'
          name={document.name}
          documentId={document.id}
          mimeType={document.mimeType}
          getLinkForPreview={getLinkForPreview}
        />,
        <DocumentDownloadButton key='download' documentId={document.id} />,
      ]}>
      <List.Item.Meta title={document.name} description={description} />
    </List.Item>
  );
};
